import { UIHeading2, UIText1 } from '@cian/ui-kit';
import * as styles from '../../BuyResultModal.css';
import * as React from 'react';
import { NBSP } from '../../../../constants';

interface INotEnoughMoneyProps {
  button: React.ReactNode;
}

export const NotEnoughMoney = (props: INotEnoughMoneyProps) => {
  const { button } = props;

  return (
    <>
      <UIHeading2>Не хватает денег</UIHeading2>

      <div className={styles['text']}>
        <UIText1>Пополните счёт, чтобы купить подписку. Активируем{NBSP}её, как только поступят деньги.</UIText1>
      </div>

      <div className={styles['button']}>{button}</div>
    </>
  );
};
